import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from '@components/toolbar';
import { DirectivesModule } from '@directives/directives.module';
import { CsIconModule } from '@components/icon';
import { MoneybackGuaranteePageComponent } from './moneyback-guarantee-page.component';

@NgModule({
  imports: [
    CommonModule,
    ToolbarModule,
    DirectivesModule,
    CsIconModule,
    MoneybackGuaranteePageComponent,
  ],
  declarations: [],
  exports: [],
})
export class MoneybackGuaranteePageModule {}

